"use strict";
angular.module("groupUserManageMentRouterModule", ['groupUserRightsModule', 'gUserManageMentModule', 'gGroupManageMentModule', 'groupManageMentLeftModule', 'accountSynchroToPersonalModule', 'accountSynchroToGroupModule','correspondentManageMentModule'])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state("manageconfig.groupmanage", {
            url: '/groupmanage',
            views: {
                'main@manageconfig': {
                    templateUrl: './manageConfig/groupUserManageMent/main_tpl.html'
                },
                'left@manageconfig.groupmanage': {
                    templateUrl: './manageConfig/groupUserManageMent/left_tpl.html',
                    controller: 'groupManageMentLeftCtrl',
                }
            }
        }).state("manageconfig.groupmanage.group", {
            url: '/group?status&groupid',
            views: {
                'right@manageconfig.groupmanage': {
                    templateUrl: './manageConfig/groupUserManageMent/group/gGroupManageMent_tpl.html',
                    controller: 'gGroupManageMentController'
                },
            }
        }).state("manageconfig.groupmanage.user", {
            url: '/user?status&groupid',
            views: {
                'right@manageconfig.groupmanage': {
                    templateUrl: './manageConfig/groupUserManageMent/user/gUserManageMent_tpl.html',
                    controller: 'gUserManageMentController'
                },
            }
        }).state("manageconfig.groupmanage.accountsynchrotogroup", {
            url: '/accountsynchrotogroup?status',
            views: {
                'right@manageconfig.groupmanage': {
                    templateUrl: './manageConfig/groupUserManageMent/accountSynchro/toGroup/accountSynchroToGroup_tpl.html',
                    controller: 'accountSynchroToGroupController'
                },
            }
        }).state("manageconfig.groupmanage.accountsynchrotopersonal", {
            url: '/accountsynchrotopersonal?status',
            views: {
                'right@manageconfig.groupmanage': {
                    templateUrl: './manageConfig/groupUserManageMent/accountSynchro/toPersonal/accountSynchroToPersonal_tpl.html',
                    controller: 'accountSynchroToPersonalController'
                },
            }
        }).state("manageconfig.groupmanage.correspondent", {
            url: '/correspondent',
            views: {
                'right@manageconfig.groupmanage': {
                    templateUrl: './manageConfig/groupUserManageMent/correspondent/correspondent_tpl.html',
                    controller: 'correspondentManageMentController'
                },
            }
        });
    }]);
